import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ActionType } from '@integration-app/sdk';
import { ListDataRecord } from './ListDataRecord';
import { IntegrationIcon } from '../../IntegrationIcon';
import { useActionInstanceContext } from '../contexts';
export const ACTION_INSTANCE_CONFIGS = {
    [ActionType.ListDataRecords]: ListDataRecord,
};
export function ActionInstanceConfig() {
    const { actionInstance } = useActionInstanceContext();
    if (!actionInstance) {
        return null;
    }
    return (_jsxs("div", { children: [_jsxs("h2", { className: 'flex flex-row items-center gap-2', children: [_jsx(IntegrationIcon, { integration: actionInstance.integration }), "Action \"", actionInstance.name, "\""] }), _jsx("div", { children: _jsx(ConfigComponent, { type: actionInstance.type }) })] }));
}
function ConfigComponent({ type }) {
    if (!ACTION_INSTANCE_CONFIGS[type]) {
        return (_jsxs(_Fragment, { children: ["\"", _jsx("kbd", { children: type }), "\" action type doesn't have configuration."] }));
    }
    const Component = ACTION_INSTANCE_CONFIGS[type];
    return _jsx(Component, {});
}
//# sourceMappingURL=index.js.map